import React from "react";
import { Link } from "react-router-dom";
import { ShieldCheck, ChevronRight } from "lucide-react";
import { STORE, waLink, resolveImg, OFFER } from "@/lib/store";

export const BikeCard = ({ bike }) => {
  const msg = `Hello ${STORE.name}, I'm interested in the ${bike.name} (${bike.category_name}). Please share availability, price and pickup details.`;
  return (
    <div
      data-testid={`bike-card-${bike.id}`}
      className="card-lift group flex flex-col overflow-hidden rounded-2xl border border-[#E6D7C8] bg-white"
    >
      <Link to={`/bikes/${bike.id}`} className="relative block aspect-[4/3] overflow-hidden bg-[#F1ECE6]">
        {bike.image_url ? (
          <img
            src={resolveImg(bike.image_url)}
            alt={`${bike.name} - ${bike.category_name} at Knoble Rides Lagos`}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="flex h-full items-center justify-center text-sm text-zinc-400">Photo coming soon</div>
        )}
        <span className="absolute left-3 top-3 rounded-full bg-[#0B0A09]/85 px-3 py-1 text-xs font-semibold text-white backdrop-blur">
          {bike.category_name}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-5">
        <h3 className="font-display text-lg font-bold leading-snug text-[#0B0A09]">
          <Link to={`/bikes/${bike.id}`} className="hover:text-[#8C5A32]">{bike.name}</Link>
        </h3>
        {bike.spec && <p className="mt-1.5 line-clamp-2 text-sm text-zinc-500">{bike.spec}</p>}

        <div
          data-testid="free-helmet-pump-badge"
          className="mt-3 inline-flex w-fit items-center gap-1.5 rounded-full bg-[#FDF8F3] px-3 py-1 text-xs font-semibold text-[#8C5A32] ring-1 ring-[#E6D7C8]"
        >
          <ShieldCheck className="h-3.5 w-3.5" /> {OFFER}
        </div>

        <div className="mt-4 flex-1" />

        <div className="flex items-center gap-2">
          <a
            data-testid={`bike-enquire-btn-${bike.id}`}
            href={waLink(msg)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-wa flex flex-1 items-center justify-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold"
          >
            Enquire on WhatsApp
          </a>
          <Link
            to={`/bikes/${bike.id}`}
            className="inline-flex items-center justify-center rounded-xl border border-[#E6D7C8] p-2.5 text-[#8C5A32] transition-colors hover:bg-[#FDF8F3]"
            aria-label={`View ${bike.name} details`}
          >
            <ChevronRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </div>
  );
};
